import { createAsyncAction } from "typesafe-actions";

import { UserActionTypes } from "./types";
import { ILoginRequest, ILoginResponse } from "app/services/default";

export const getUsersAsync = createAsyncAction(
    UserActionTypes.GET_USER_DETAIL_REQUEST,
    UserActionTypes.GET_USER_DETAIL_SUCCESS,
    UserActionTypes.GET_USER_DETAIL_FAILTURE
)<ILoginRequest, ILoginResponse, any>();
